import {Box, IconButton, Tooltip} from "@mui/material";
import {alpha} from "@mui/material/styles";
import type {MouseEvent, ReactNode} from "react";

interface Props {
    label: string;
    icon: ReactNode;
    /** The format is on at the cursor, or the button's popup is open. */
    active?: boolean;
    disabled?: boolean;
    onClick: (event: MouseEvent<HTMLButtonElement>) => void;
}

export default function ToolbarButton({label, icon, active = false, disabled = false, onClick}: Props) {
    return (
        // `describeChild`: the button names itself, so the wrapper is not labelled a second time.
        <Tooltip title={label} describeChild>
            {/* A disabled button fires no pointer events, so the tooltip listens on this wrapper. */}
            <Box component={'span'} sx={{display: 'inline-flex'}}>
                <IconButton
                    size={'small'}
                    aria-label={label}
                    aria-pressed={active}
                    disabled={disabled}
                    // The text keeps its focus and its selection.
                    onMouseDown={event => event.preventDefault()}
                    onClick={onClick}
                    sx={theme => ({
                        width: 32,
                        height: 32,
                        borderRadius: 1,
                        color: active ? 'primary.main' : 'text.secondary',
                        bgcolor: active ? alpha(theme.palette.primary.main, 0.12) : 'transparent',
                        '&.Mui-disabled': {color: 'action.disabled'},
                    })}
                >
                    {icon}
                </IconButton>
            </Box>
        </Tooltip>
    );
}
